'use client';

import { ChatBubbleLeftRightSolid } from '@byway/icons';
import clsx from 'clsx';
import { useLocale, useTranslations } from 'next-intl';
import { Link } from '~/components/Link';
import useJourneyData from '~/hooks/useJourneyData';
import type { Locale } from '~/i18n/i18n-config';
import { getPathname } from '~/i18n/navigation';
import styles from './ContactUsButton.module.css';

export const ContactUsButton = ({ isCompact = false }: Readonly<{ isCompact?: boolean }>) => {
  const t = useTranslations();
  const locale = useLocale() as Locale;
  const { actions } = useJourneyData();

  const contactHref = actions?.contact && getPathname({ href: actions.contact, locale });

  // `isExternal` forces a native <a>: trip pages live in (default), /contact resolves under [lang]
  // via the proxy rewrite, and a soft-nav across that boundary 404s until refresh.
  return (
    <Link dataTestId="contact-us-link" data-ua-click="contact-button" href={contactHref} isExternal hasUnderline>
      <span className={styles.icon}>
        <ChatBubbleLeftRightSolid decorative isInline size="small" />
      </span>
      <span className={clsx(styles.label, isCompact && styles.labelCompact)}>{t('common.contact')}</span>
    </Link>
  );
};
